<div *ngIf="navData" fxLayoutGap="10px" class="data-wrap pt-0" fxLayout="column">
    <div class="title mt-0" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon class="title-icon dark-blue {{ navData.data.class }}">{{ navData.data.icon }}</mat-icon>
        <div class="title-label dark-blue {{ navData.data.class }}" fxFlex="grow">{{ navData.data.title }}</div>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
        <app-image-view
            [ngStyle]="{ minWidth: '110px' }"
            [media_id]="navData.data.resource.media"
            paddingBottom="70px"
        ></app-image-view>
        <div fxLayout="column" fxLayoutAlign="center start">
            <span class="dark-blue res-title">{{ navData.data.resource.title }}</span>
            <!-- <div *ngIf="!navData.data.resource.price || navData.data.resource.price === 0" class="price-wrap">
                <div class="dark-blue-color">FREE!</div>
            </div> -->
            <!-- <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px" class="small signoff-date"
                ><span i18n>Requested at</span> <span>{{ navData.data.enrollment.requested_at }}</span></span
            > -->
        </div>
    </div>
    <!-- <div *ngIf="!!this.navData.data.enrolledOccId && !!availableOccasionsToEnroll?.length" i18n class="excludes-hint">
        You are waitlisted for this resource on the specified date. You can still enroll for other dates.
    </div> -->
    <!-- <ng-container *ngIf="this.navData.data.resource.user_collaboration?.enroll_approval_required?.status"> -->
    <ng-container *ngIf="!!navData.data.descs?.length">
        <ng-container *ngFor="let desc of navData.data.descs">
            <div [innerHTML]="desc | innerHtml : 'tool_desc'" *ngIf="!!desc" class="excludes-hint"></div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="occasion_dates?.length && navData.data?.type == 'enrollRequest'">
        <div class="occasion-dates" fxLayout="column" fxLayoutGap="10px">
            <span *ngIf="!!availableOccasionsToEnroll?.length" class="dark-blue head" i18n>Select occasion date:</span>
            <mat-radio-group fxLayout="column" fxLayoutGap="8px" [formControl]="selectedOccasionId">
                <ng-container *ngFor="let date of occasion_dates">
                    <mat-radio-button
                        [disabled]="
                            !Utils.isValidToEnrollOccasionByDate(date) ||
                            !date.id ||
                            date.ispassed ||
                            !Utils.isValidToEnrollOccasionBySeats(date, navData.data.resource.enrollmentRequiredStatus)
                        "
                        [value]="date.id"
                    >
                        <div fxLayout="column">
                            <span fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="3px" class="dark-blue">
                                <span class="capitalize" *ngIf="date.start_date && date.end_date">
                                    {{ date.start_date | kdDateFormat : 'MMM DD, YYYY' }} -
                                    {{ date.end_date | kdDateFormat : 'MMM DD, YYYY' }}
                                </span>
                                <span class="capitalize" *ngIf="date.start_date && !date.end_date">
                                    {{ date.start_date | kdDateFormat : 'MMM DD, YYYY' }}
                                </span>
                                <ng-container
                                    *ngIf="
                                        Utils.isValidToEnrollOccasionBySeats(
                                            date,
                                            navData.data.resource.enrollmentRequiredStatus
                                        )
                                    "
                                >
                                    <ng-container *ngIf="!Utils.isUnlimitedSeatsOccasion(date)">
                                        <span>
                                            ({{ date.total_seats! - (date.approved_count ?? 0) }}
                                            <span class="dark-blue" i18n>&nbsp;seats left</span>)
                                        </span>
                                    </ng-container>
                                    <ng-container *ngIf="Utils.isUnlimitedSeatsOccasion(date)">
                                        <span class="dark-blue" i18n>(Open seats)</span>
                                    </ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        !Utils.isValidToEnrollOccasionBySeats(
                                            date,
                                            navData.data.resource.enrollmentRequiredStatus
                                        )
                                    "
                                >
                                    <span class="dark-blue" i18n>No seats left</span>
                                </ng-container>
                                <button
                                    *ngIf="
                                        !date.location &&
                                        (date.target_group || date.activity || date.other || date.grib)
                                    "
                                    class="add-date-btn expand-btn-no-location"
                                    color="primary"
                                    mat-icon-button
                                    (click)="date.expanded = !date.expanded"
                                    matTooltip="More fields to be added"
                                    i18n-matTooltip
                                >
                                    <mat-icon>{{ date.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                                </button>
                            </span>
                            <div
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                                fxLayoutGap="3px"
                                *ngIf="date.location || date.target_group || date.activity || date.other || date.grib"
                            >
                                <span
                                    *ngIf="date.location"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    class="location-wrap"
                                >
                                    <mat-icon>location_on</mat-icon>
                                    <span>{{ date.location }}</span>
                                </span>

                                <button
                                    *ngIf="
                                        date.location && (date.target_group || date.activity || date.other || date.grib)
                                    "
                                    class="add-date-btn expand-btn duplicate"
                                    color="primary"
                                    mat-icon-button
                                    (click)="date.expanded = !date.expanded"
                                    matTooltip="More fields to be added"
                                    i18n-matTooltip
                                >
                                    <mat-icon>{{ date.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                                </button>
                            </div>
                            <div
                                class="expanded-items"
                                [ngClass]="{ 'expanded-no-location': date.expanded && !date.location }"
                                *ngIf="date.expanded"
                            >
                                <div class="expanded-item" *ngIf="date.target_group">
                                    <div class="expanded-label">Target group:</div>
                                    <span>{{ date.target_group }}</span>
                                </div>

                                <div class="expanded-item" *ngIf="date.activity">
                                    <div class="expanded-label">Activity:</div>
                                    <span>{{ date.activity }}</span>
                                </div>

                                <div class="expanded-item" *ngIf="date.other">
                                    <div class="expanded-label">Other:</div>
                                    <span>{{ date.other }}</span>
                                </div>

                                <div class="expanded-item" *ngIf="date.grib">
                                    <div class="expanded-label">GRIB:</div>
                                    <span>{{ date.grib }}</span>
                                </div>
                            </div>
                        </div>
                    </mat-radio-button>
                </ng-container>
            </mat-radio-group>
        </div>
    </ng-container>
    <!-- </ng-container> -->
    <div *ngIf="!!navData.data.inputDesc" class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
        <span>{{ navData.data.inputDesc }}</span>
        <mat-form-field cdkTrapFocus appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
            <textarea
                cdkFocusInitial
                #taskInput
                matInput
                type="text"
                [formControl]="message"
                placeholder="Message to the admin"
                i18n-placeholder
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="50"
            ></textarea>
        </mat-form-field>
    </div>
    <ng-container [ngTemplateOutlet]="actions"></ng-container>
</div>

<ng-template #actions>
    <div
        *ngIf="!!navData.data.actions?.length"
        class="action"
        fxLayout="row-reverse"
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
    >
        <ng-container *ngFor="let action of navData.data.actions">
            <button
                *ngIf="action.value !== 10"
                fxFlex="0 0 auto"
                class="mobile-button positive {{ action.class }}"
                [attr.data-testid]="action.value ? 'resource-enroll-confirm' : 'resource-enroll-cancel'"
                (click)="onCloseAction(action)"
                mat-button
                i18n
            >
                {{ action.label }}
            </button>
            <button
                *ngIf="action.value === 10"
                fxFlex="0 0 auto"
                class="{{ action.class }} green"
                (click)="onCloseAction(action)"
                mat-icon-button
                matTooltip="Edit Occasions"
                i18n-matTooltip="@@editOccasions"
            >
                <mat-icon>edit</mat-icon>
            </button>
        </ng-container>
    </div>
</ng-template>
